// extracted by mini-css-extract-plugin
export default {"layout":"_5D234ygC","mobile-button":"_5D3cVvN7","desktop-button":"_5D3S3Jzw","question":"_5D2r7yTm","question__media-wrapper":"_5Dt8WBLp","question__text":"_5D3x7txu"};